import React from "react";
import { Link } from "react-router-dom";
import * as hrmsService from "../../services/hrmsService";
import { BalanceCards } from "./LeaveMy";
import PunchCard from "./time/PunchCard";
import { EmptyState, LoadState, PageHeader } from "./hrComponents";
import { useHr } from "./HrGate";
import { cardStyle, formatDate, pageStyle, statusBadge, statusLabel, todayYmd, useLoad } from "./hrUi";

// The employee's home: leave balances, the next holidays and the shortcuts they use most.
export default function MySpace() {
  const { access } = useHr();
  const balances = useLoad(() => hrmsService.getLeaveBalance(), []);
  const holidays = useLoad(() => hrmsService.getMyHolidays(), []);
  const pending = useLoad(() => hrmsService.getApprovalCount(), []);
  const today = todayYmd();
  const upcoming = (holidays.data?.holidays || []).filter((h) => h.holiday_date >= today).slice(0, 5);
  const toApprove = Number(pending.data?.pending) || 0;

  const tile = (to, title, text) => (
    <Link to={to} style={{ ...cardStyle, padding: "14px 18px", minWidth: 200, textDecoration: "none", color: "inherit", flex: "1 1 200px" }}>
      <div style={{ fontWeight: 600, color: "#C9194A" }}>{title}</div>
      <div style={{ fontSize: 13, color: "#6B7280" }}>{text}</div>
    </Link>
  );

  return (
    <div style={pageStyle}>
      <PageHeader title={`Hello${access.employee?.full_name ? `, ${access.employee.full_name.split(" ")[0]}` : ""}`} subtitle={access.employee?.employee_code ? `Employee ${access.employee.employee_code}` : undefined} />

      <div className="mb-4">
        <PunchCard />
      </div>

      <div className="d-flex flex-wrap gap-3 mb-4">
        {tile("/hr/leave", "Apply for leave", "Balances, requests and the team calendar")}
        {tile("/hr/attendance", "Attendance", "My days, corrections and overtime")}
        {tile("/hr/roster", "My roster", "Shifts and swap requests")}
        {tile("/hr/me", "My profile", "Personal details, bank, documents")}
        {access.features?.PAYROLL ? tile("/hr/payslips", "My payslips", "Monthly payslips as password-protected PDFs") : null}
        {tile("/hr/documents", "Documents & letters", "Company policies and HR letters")}
        {tile("/hr/approvals", toApprove ? `${toApprove} waiting for you` : "Approvals", "Requests to decide and ones you made")}
      </div>

      <h6 className="mb-2">My leave balance</h6>
      <LoadState loading={balances.loading} error={balances.error} onRetry={balances.reload} rows={2}>
        <BalanceCards balances={balances.data?.balances || []} />
      </LoadState>

      <h6 className="mt-4 mb-2">Upcoming holidays</h6>
      <LoadState loading={holidays.loading} error={holidays.error} onRetry={holidays.reload} rows={2}>
        {upcoming.length === 0 ? (
          <EmptyState title="No upcoming holidays" text={holidays.data?.calendar ? undefined : "No holiday calendar has been assigned to you yet."} />
        ) : (
          <div style={{ ...cardStyle, padding: "4px 18px" }}>
            {upcoming.map((h) => (
              <div key={`${h.holiday_date}${h.name}`} className="d-flex justify-content-between align-items-center py-2" style={{ borderBottom: "1px solid #F3F4F6", fontSize: 14 }}>
                <span>
                  <strong>{formatDate(h.holiday_date)}</strong> · {h.name}
                </span>
                <span>
                  {h.type !== "PUBLIC" ? <span style={statusBadge(h.type === "OPTIONAL" ? "PROBATION" : "PENDING")}>{statusLabel(h.type)}</span> : null}
                  {!h.confirmed ? <span style={{ fontSize: 12, color: "#92400E", marginLeft: 6 }}>date to be confirmed</span> : null}
                </span>
              </div>
            ))}
          </div>
        )}
      </LoadState>
    </div>
  );
}
